import React, { PropTypes } from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { ADMIN_ROOT } from 'common/variables';
import StarRating from 'common/components/star_rating';

const NameDenseItem = ({ item }) => {
  const link = `${ADMIN_ROOT}/project/${item.project}/entry/${item.id}/`;
  const revision = item.revisions[0];
  const authorUsernameTrimmed = (
    item.author_username.length > 25? item.author_username.substring(0, 25) : item.author_username
  );

  return (
    <tr>
      <td className="entry-name">
        <Link to={link}>{ revision.name }</Link>
      </td>
      <td className="hide-for-small-only">
        <Link to={`${ADMIN_ROOT}/creative/${item.author}/`} target="_blank">
          { authorUsernameTrimmed }
        </Link>
      </td>
      <td className="hide-for-small-only">{ moment(revision.created_at).fromNow() }</td>
      <td>
        { item.withdrawn && <span className="message">withdrawn</span> }
        { item.eliminated && <span className="message">eliminated</span> }
        <StarRating key={item.id} readonly={true} initialRate={revision.score || 0} />
      </td>
    </tr>
  );
}

NameDenseItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default NameDenseItem;



// WEBPACK FOOTER //
// ./admin/components/entries/name_dense_item.jsx